import React, { useState } from "react";
import { Button, Input, Modal, Typography, Form } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { isAuthenticated } from "../../../commons/Auth/auth";
import { Error, Success } from "../../../commons/Messages/Messages";
import axios from "axios";

import { useTranslation } from "react-i18next";
const { Text } = Typography;

const AddBoard = ({ updateParent }) => {
  const { t } = useTranslation("dashboard");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields();
  };

  const onFinish = async values => {
    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/ticketBoards/add`,
        {
          title: values.title,
          createdFrom: isAuthenticated()?._id,
          createdAt: new Date()
        },
        {
          headers: { Authorization: "Bearer " + localStorage.getItem("token") }
        }
      );

      if (res.status === 200 || res.status === 304) {
        Success(t(res.data.successMessage));
        updateParent();
        handleCancel();
      } else {
        Error(res.data.errorMessage);
      }
    } catch (err) {
      Error(err.response?.data?.errorMessage || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
        {t("New Board")}
      </Button>

      <Modal
        title={
          <div className="tkt-modal-title">
            <span>{t("Create Board")}</span>
            <span className="tkt-modal-subtitle">{t("Setup a dedicated workspace.")}</span>
          </div>
        }
        open={isModalOpen}
        onCancel={handleCancel}
        onOk={() => form.submit()}
        confirmLoading={loading}
        okText={t("Create")}
        cancelText={t("Cancel")}
        centered
        width={440}
        rootClassName="tkt-modal"
      >
        <Form form={form} layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="title"
            label={<Text strong>{t("Board Name")}</Text>}
            rules={[{ required: true, message: t("Please input the board title!") }]}
          >
            <Input size="large" placeholder={t("E.g. Technical Support, Client Projects")} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AddBoard;
